export default __webpack_public_path__ + "static/media/UnsellectedDropDown.68e0b60b.svg";